import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { RSForm } from "../index";
import { capitaliseFirstLetter } from "../general/utils";
function FormTextField(props) {
    const { id, name, centered, label, accepter, helpText, ...rest } = props;
    let style = {};
    centered ? (style = { ...style, textAlign: "center" }) : null;
    return (_jsxs(RSForm.Group, { controlId: `form-${id}-${capitaliseFirstLetter(name)}`, children: [_jsx(RSForm.ControlLabel, { children: label }), _jsx(RSForm.Control, { style: style, name: name, accepter: accepter, ...rest }), helpText && _jsx(RSForm.HelpText, { children: helpText })] }));
}
export default FormTextField;
